import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type FadeInProps = {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
  distance?: number;
  className?: string;
  as?: "div" | "li";
};
export function FadeIn({
  children,
  delay = 0,
  duration = 0.28,
  distance = 16,
  className = "",
  as = "div"
}: FadeInProps) {
  const reduceMotion = useReducedMotion();
  const animationProps = {
    className,
    initial: reduceMotion ? false : {
      opacity: 0,
      y: distance
    },
    whileInView: reduceMotion ? undefined : {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.18
    },
    transition: {
      duration,
      delay,
      ease: [0.23, 1, 0.32, 1] as const
    }
  };
  if (as === "li") {
    return <motion.li {...animationProps} data-id="element-63" data-mp="w0vtn57i3zx">{children}</motion.li>;
  }
  return <motion.div {...animationProps} data-id="element-64" data-mp="to3cg1tob8m">{children}</motion.div>;
}